import { Host, h } from '@stencil/core';
export class AibaTabs {
  constructor() {
    this.componentWillLoad = async () => {
      let dataFromTabsLoad = {
        tabs: ['OVERVIEW', 'ANALYSIS'],
        activeTabContent: { OVERVIEW: h("aiba-analysis-graph-view", null), ANALYSIS: h("aiba-analysis-tab", null) },
        activeTab: 'OVERVIEW',
      };
      if (this.handlers && this.handlers.handleTabsLoad) {
        dataFromTabsLoad = await this.handlers.handleTabsLoad(this.layOutData, this.handlers);
      }
      if (dataFromTabsLoad) {
        this.tabs = (dataFromTabsLoad === null || dataFromTabsLoad === void 0 ? void 0 : dataFromTabsLoad.tabs) ? dataFromTabsLoad.tabs : this.tabs;
        this.activeTabContent = (dataFromTabsLoad === null || dataFromTabsLoad === void 0 ? void 0 : dataFromTabsLoad.activeTabContent) ? dataFromTabsLoad.activeTabContent : this.activeTabContent;
        this.activeTab = (dataFromTabsLoad === null || dataFromTabsLoad === void 0 ? void 0 : dataFromTabsLoad.activeTab) ? dataFromTabsLoad.activeTab : this.activeTab;
      }
      if (this.handlers && this.handlers.handleActiveTabOnLoad) {
        await this.handlers.handleActiveTabOnLoad(dataFromTabsLoad);
      }
    };
    this.styles = undefined;
    this.classes = undefined;
    this.data = undefined;
    this.handlers = undefined;
    this.tabs = ['tab1', 'tab2'];
    this.activeTabContent = { tab1: 'tab1 Content', tab2: 'tab2 content' };
    this.activeTab = this.tabs.length > 0 ? this.tabs[0] : 'tab1';
    this.layOutData = this.data;
  }
  async handleTabClick(event, tabName) {
    this.activeTab = tabName;
    if (this.handlers && this.handlers.handleTabsChanged) {
      await this.handlers.handleTabsChanged(tabName);
    }
    console.log('event test', event);
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g;
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
      this.classes = ((_a = this.data) === null || _a === void 0 ? void 0 : _a.classes) ? (_b = this.data) === null || _b === void 0 ? void 0 : _b.classes : null;
    }
    return (h(Host, { class: this.classes && this.classes }, this.styles && h("style", null, this.styles), ((_d = (_c = this.layOutData) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.headerData) && (h("div", { class: "header-block" }, (_g = (_f = (_e = this.layOutData) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.headerData) === null || _g === void 0 ? void 0 : _g.map(elem => {
      if (elem && elem.name === 'aiba-label') {
        return h("aiba-label", Object.assign({}, elem.data));
      }
    }))), h("div", { class: "tabwrapper" }, this.tabs.map((tabname) => (h("div", { class: (tabname === this.activeTab ? 'active' : '') + ' title', onClick: async (event) => await this.handleTabClick(event, tabname), onKeyDown: async (event) => {
        if (event.key === 'Enter') {
          await this.handleTabClick(event, tabname);
        }
      }, tabIndex: 0, role: "button" }, this.layOutData &&
      this.layOutData.data &&
      this.layOutData.data.elements.map(element => {
        var _a;
        if (element.name === 'aiba-label') {
          return h("aiba-label", Object.assign({ tag: (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.tag, text: tabname }, element.data));
        }
        if (element.name === 'aiba-icon') {
          return h("aiba-icon", Object.assign({}, element === null || element === void 0 ? void 0 : element.data));
        }
      }))))), this.layOutData &&
      this.layOutData.data &&
      this.layOutData.data.elements.map(element => {
        if (element.name === 'aiba-tab-content') {
          return h("div", { class: "tab-content" }, this.activeTabContent[this.activeTab]);
        }
      })));
  }
  static get is() { return "aiba-tabs"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-tabs.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-tabs.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "tabs": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "tabs",
        "reflect": false,
        "defaultValue": "['tab1', 'tab2']"
      },
      "activeTabContent": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "active-tab-content",
        "reflect": false,
        "defaultValue": "{ tab1: 'tab1 Content', tab2: 'tab2 content' }"
      }
    };
  }
  static get states() {
    return {
      "activeTab": {},
      "layOutData": {}
    };
  }
}
//# sourceMappingURL=aiba-tabs.js.map
